import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  Modal,
  TextField,
  Typography
} from "@mui/material";
import { postNotification } from "../../../components/utilities/Notifications";

import { Formik } from "formik";
import * as Yup from "yup";
import { globalVariables } from "../../../global/GlobalVariables";
import ArmyPicker from "../../../components/utilities/ArmyPicker";
import ModalLoadingFull from "../../../components/modals/ModalLoadingFull";
import { useConfirm } from "material-ui-confirm";
import ArmyListComponent from "./ArmyListComponent";
import GenericPicker from "../../../components/utilities/GenericPicker";
import { handlePagingAll } from "../../../components/api/APIUtilities";
import {
  getData,
  postData,
  validateEmail
} from "../../../components/utilities/UtilityFunctions";
import {
  BCPEllipsisVertical,
  BCPRotateRight,
  BCPXmark
} from "../../../components/icons/bcp/BCPIcons";
import {
  getEnvironmentVariable,
  supportsUYPlatformFeatures
} from "../../../global/environmentVariables";
import { PlayerGroupInfoModal } from "./SubComponents/EventRosterModals";
import { PlayerOptionsMenu } from "./SubComponents/EventRosterMenus";
const SUPPORTS_UY_PLATFORM_FEATURES = supportsUYPlatformFeatures();
const COMPANY_FLAG = getEnvironmentVariable("COMPANY_FLAG");

const TermsOfServiceBox = () => {
  return (
    <Box>
      <Typography variant="caption" paragraph>
        By clickin "I agree", you agree to the Terms of Service for the {}{" "}
        Website or Services, EULA, and Privacy Policy. You must be 13 years of
        age or older to use {getEnvironmentVariable("COMPANY_NAME")}. By
        agreeing you confirm that you are over 18, or if you are between 13 and
        18 years of age, you have your parent or legal guardian's permission to
        use {getEnvironmentVariable("COMPANY_NAME")}
        We take privacy seriously and collect the following information to
        administer your account, scores, rankings and ticket sales. Your name is
        shared publicly as part of event rosters, pairings, placings and
        rankings. Your email address is kept private and used as our unique
        identifier and only shared with the Event Organizers of events you
        participate in, Team owners which you are a member of, and Vendors you
        make purchases from. {getEnvironmentVariable("COMPANY_NAME")} may
        contact you occasionally in relation to services requested.
      </Typography>
      <Typography variant="caption">
        Visit these links for our complete{" "}
        <Link href="/privacy" target="_blank">
          Privacy Policy
        </Link>{" "}
        and{" "}
        <Link href="/eula" target="_blank">
          EULA
        </Link>
        .
      </Typography>
    </Box>
  );
};

export default function OrganizePlayerModal(props) {
  const { t } = useTranslation("translation", {
    keyPrefix: "components.OrganizePlayerModal"
  });
  const { t: tArmyList } = useTranslation("translation", {
    keyPrefix: "components.ArmyListComponent"
  });
  const {
    organize,
    captain,
    event,
    player,
    armies,
    setPlayer,
    teamSubmitPlayer,
    teamCancelPlayer,
    setRefreshPlayers,
    setSavedPlayer,
    teamPlayerId,
    setCaptainIsPlayer,
    setTeamPlayer,
    deletePlayer
  } = props;

  var globalVars = globalVariables();
  const confirm = useConfirm();

  const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);

  const [armyName, setArmyName] = useState(player?.faction?.name);
  const [characters, setCharacters] = useState(null);

  const [armyModalOpen, setArmyModalOpen] = useState(false);
  const [armyDict, setArmyDict] = useState({});

  const [groupInfoModalOpen, setGroupInfoModalOpen] = useState(false);
  const [transaction, setTransaction] = useState(null);

  const [passwordUpdated, setPasswordUpdated] = useState(false);

  const [teams, setTeams] = useState(null);
  const [formKey, setFormKey] = useState(0);

  const submitPlayer = async (values) => {
    if (values.checkedIn) {
      var error = false;

      if (
        event.gameSystem?.hasFactions &&
        (!values.armyId || values.armyId === "")
      ) {
        postNotification(
          "error",
          t("validationErrors.pleaseSelectFaction", {
            factionLabel: event?.gameSystem?.factionLabel || "Faction"
          })
        );
        error = true;
      }
      if (
        event.gameSystem?.subFactionRequired &&
        (!values.subFactionId || values.subFactionId === "")
      ) {
        postNotification(
          "error",
          t("validationErrors.pleaseSelectSubFaction", {
            subFactionLabel: event?.gameSystem?.subFactionLabel || "Sub Faction"
          })
        );
        error = true;
      }
      if (event?.gameSystem?.supportsCharacters) {
        postNotification(
          "error",
          t("validationErrors.pleaseSelectCharacter", {
            characterLabel: event?.gameSystem?.characterLabel || "Character"
          })
        );
        error = true;
      }

      if (
        event.enablePasswords &&
        !event.passwordlessScoring &&
        values.pin === "" &&
        !player.hasPin
      ) {
        postNotification("error", t("notifications.errors.pleaseEnterPin"));
        error = true;
      }
      if (error) return;
    }
    setLoading(true);
    const isNewPlayer = !player.id;
    try {
      if (player.id) {
        let body = { set: {}, unset: {} };
        if (values.checkedIn !== undefined) {
          body.set.checkedIn = values.checkedIn;
        }
        if (values.pin && passwordUpdated) {
          body.set.pin = values.pin;
        }
        if (values.teamId) {
          body.set.teamId = values.teamId;
        } else {
          body.unset.teamId = true;
          body.unset.teamName = true;
        }
        if (values.armyId) {
          body.set.armyId = values.armyId;
        } else {
          body.unset.armyId = true;
          body.unset.armyName = true;
        }
        if (values.subFactionId) {
          body.set.subFactionId = values.subFactionId;
        } else {
          body.unset.subFactionId = true;
          body.unset.subFactionName = true;
        }
        if (values.characterId) {
          body.set.characterId = values.characterId;
        } else {
          body.unset.characterId = true;
          body.unset.characterName = true;
        }
        if (values.userId) {
          body.set.userId = values.userId;
        }
        if (values.email) {
          body.set.email = values.email.trim();
        }
        if (values.firstName) {
          body.set.firstName = values.firstName.trim();
        }
        if (values.lastName) {
          body.set.lastName = values.lastName.trim();
        }
        if (values.systemId && values.systemId !== "") {
          body.set.systemId = values.systemId;
        }
        if (values.fixedTable && values.fixedTable !== "") {
          body.set.fixedTable = values.fixedTable;
        } else {
          body.unset.fixedTable = true;
        }

        let savedPlayer = await postData(`/players/${player.id}`, {
          body: body
        });
        if (setSavedPlayer) {
          setSavedPlayer(savedPlayer);
        }
      } else {
        let body = {};
        if (values.eventId) {
          body.eventId = values.eventId;
        }
        if (values.teamPlayerId) {
          body.teamPlayerId = values.teamPlayerId;
        }
        if (values.checkedIn !== undefined) {
          body.checkedIn = values.checkedIn;
        }
        if (values.pin && passwordUpdated) {
          body.pin = values.pin;
        }
        if (values.teamId) {
          body.teamId = values.teamId;
        }
        if (values.armyId) {
          body.armyId = values.armyId;
          let army = armies.filter((army) => {
            return (
              army.id === values.armyId ||
              (army?.childArmies?.length &&
                army.childArmies.filter(
                  (childArmy) => childArmy?.id === values?.armyId
                )?.length)
            );
          })?.[0];
          if (army && army.id !== values.armyId) {
            army = army?.childArmies?.filter(
              (childArmy) => childArmy?.id === values?.armyId
            )?.[0];
            body.army = army;
          }
        }
        if (values.subFactionId) {
          body.subFactionId = values.subFactionId;
        }
        if (values.characterId) {
          body.characterId = values.characterId;
        }

        if (values.userId) {
          body.userId = values.userId;
        }
        body.user = {};
        if (values.email) {
          body.user.email = values.email.trim();
          body.email = values.email.trim();
        }
        if (values.firstName) {
          body.user.firstName = values.firstName.trim();
          body.firstName = values.firstName.trim();
        }
        if (values.lastName) {
          body.user.lastName = values.lastName.trim();
          body.lastName = values.lastName.trim();
        }
        if (values.systemId && values.systemId !== "") {
          body.systemId = values.systemId;
          if (event?.gameSystem?.systemIdName) {
            body.systemIdKey = event?.gameSystem?.systemIdName;
          }
        }
        if (values.fixedTable && values.fixedTable !== "") {
          body.fixedTable = values.fixedTable;
        }

        if (teamSubmitPlayer) {
          teamSubmitPlayer(body);
          return;
        } else {
          let savedPlayer = await postData(`/players`, {
            body: body
          });
          if (setSavedPlayer) {
            setSavedPlayer(savedPlayer);
          }
        }
      }
      setRefreshPlayers(true);
      if (isNewPlayer && !teamSubmitPlayer) {
        postNotification(
          "success",
          values.checkedIn
            ? t("notifications.success.playerCheckedIn")
            : t("notifications.success.playerRegistered")
        );
        setPlayer({});
        setPasswordUpdated(false);
        setFormKey((prev) => prev + 1);
      } else {
        const originalEmail = (
          player?.email ||
          player?.user?.email ||
          ""
        ).trim();
        if (values.email && values.email.trim() !== originalEmail) {
          postNotification("success", t("notifications.success.emailUpdated"));
        }
        setPlayer(null);
      }
    } catch (err) {
      postNotification("error", err);
    }
    setLoading(false);
  };

  const handleSetTeams = async (player) => {
    try {
      if (!player?.userId) {
        setTeams(null);
        return;
      }

      const apiTeams = await getData(`/users/${player?.userId}/teams`);

      let newTeams = [];
      if (apiTeams && apiTeams?.length) {
        apiTeams.sort((a, b) => {
          let teamA = a?.name?.toLowerCase();
          let teamB = b?.name?.toLowerCase();

          if (teamA > teamB) return 1;
          if (teamA < teamB) return -1;

          return 0;
        });

        apiTeams.forEach((team) =>
          newTeams.push({ label: team?.name, value: team?.id })
        );

        setTeams(newTeams);
      } else {
        setTeams(null);
      }
    } catch (err) {}
  };

  useEffect(() => {
    const go = async () => {
      setArmyName(player?.faction?.name);

      if (player) {
        await handleSetTeams(player);
      }

      if (player?.transactionId) {
        setLoading(true);
        try {
          var apiTransaction = await getData(
            `/transactions/${player.transactionId}`,
            {
              queryStringParameters: {
                "expand[]": ["refund"]
              }
            }
          );
          setTransaction(apiTransaction);
        } catch (err) {
          if (err?.response?.status !== 403) postNotification("error", err);
          setTransaction(null);
        }
        setLoading(false);
      } else {
        setTransaction(null);
      }
    };
    go();
  }, [player]);

  useEffect(() => {
    var newDict = {};
    if (armies?.length) {
      for (let army of armies) {
        let subFactions = [];
        if (army.subFactions?.length) {
          for (let subFaction of army.subFactions) {
            subFactions.push({ value: subFaction.id, label: subFaction.name });
          }

          subFactions.sort((a, b) => {
            var labelA = a.label.toLowerCase();
            var labelB = b.label.toLowerCase();
            if (labelA > labelB) return 1;
            if (labelA < labelB) return -1;
            return 0;
          });
        }
        newDict[army.id] = subFactions;

        if (army.childArmies?.length) {
          for (let childArmy of army.childArmies) {
            subFactions = [];
            if (childArmy.subFactions?.length) {
              for (let subFaction of childArmy.subFactions) {
                subFactions.push({
                  value: subFaction.id,
                  label: subFaction.name
                });
              }

              subFactions.sort((a, b) => {
                var labelA = a.label.toLowerCase();
                var labelB = b.label.toLowerCase();
                if (labelA > labelB) return 1;
                if (labelA < labelB) return -1;
                return 0;
              });
            }
            newDict[childArmy.id] = subFactions;
          }
        }
      }
    }
    setArmyDict(newDict);
  }, [armies]);

  useEffect(() => {
    const check = async () => {
      if (!armyName) {
        setCharacters([]);
        return;
      }

      var apiCharacters = await handlePagingAll("/cards", {
        gameSystemId: event?.gameSystem?.id || event?.gameSystemId,
        faction: armyName,
        cardType: COMPANY_FLAG === "shard-bugs" ? "Cosmic Avatar" : "Character"
      });
      setCharacters(
        apiCharacters.map((el) => {
          return {
            value: el.id,
            label: el.name
          };
        })
      );
    };

    if (!event?.gameSystem?.supportsCharacters) {
      return;
    }

    setCharacters(null);
    check();

    // eslint-disable-next-line
  }, [armyName]);

  return (
    <>
      <Modal
        disableAutoFocus
        open={Boolean(player)}
        onClose={() => {
          if (teamCancelPlayer) {
            teamCancelPlayer(player);
          }
          setPlayer(null);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        {player ? (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: ["95vw", "85vw", 600],
              minHeight: "95vh",
              maxHeight: "95vh",
              overflowY: "scroll",
              bgcolor: "background.paper",
              border: "1px solid rgba(0, 0, 0, 0.12)",
              borderRadius: 1,
              boxShadow: 24,
              p: 4
            }}
          >
            <IconButton
              aria-label="cancel"
              color="error"
              sx={{ position: "absolute", top: "4px", right: "4px" }}
              onClick={() => {
                if (teamCancelPlayer) {
                  teamCancelPlayer(player);
                }
                setPlayer(null);
              }}
            >
              <BCPXmark />
            </IconButton>
            <Grid
              container
              spacing={2}
              sx={{
                pb: 1,
                mb: 2,
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
              }}
            >
              <Grid item xs={12}>
                <Typography variant="h4" component="h2">
                  {t("playerDetails")}
                </Typography>
                {!player.id && formKey > 0 && (
                  <Typography
                    variant="body2"
                    color="success.main"
                    sx={{ mt: 1, fontWeight: 500 }}
                  >
                    ✓ Ready for next player
                  </Typography>
                )}
              </Grid>
            </Grid>

            <Formik
              key={formKey}
              initialValues={{
                email: player?.email || player?.user?.email || "",
                firstName: player?.firstName || player?.user?.firstName || "",
                lastName: player?.lastName || player?.user?.lastName || "",
                fixedTable: player?.fixedTable || "",
                teamId: player?.teamId || player?.team?.id || "",
                armyId: player?.armyId || player?.factionId || "",
                subFactionId: player.subFactionId || "",
                characterId: player.characterId || "",
                pin: player.hasPin ? "****" : "",
                systemId: player.systemId || ""
              }}
              enableReinitialize
              validationSchema={Yup.object().shape({
                email: event?.gameSystem?.emailRequired
                  ? Yup.string()
                      .nullable()
                      .max(128)
                      .email(t("validationErrors.emailInvalid"))
                      .required(t("validationErrors.required"))
                  : Yup.string()
                      .nullable()
                      .max(128)
                      .email(t("validationErrors.emailInvalid")),
                firstName: Yup.string()
                  .max(128)
                  .test(
                    t("validationErrors.firstNameRequired"),
                    t("validationErrors.required"),
                    (value, el) => {
                      return value && value.trim() !== "";
                    }
                  )
                  .required(t("validationErrors.required")),
                lastName: Yup.string()
                  .max(128)
                  .test(
                    t("validationErrors.lastNameRequired"),
                    t("validationErrors.required"),
                    (value, el) => {
                      return value && value.trim() !== "";
                    }
                  )
                  .required(t("validationErrors.required")),
                pin: Yup.string().max(255),
                fixedTable: Yup.number().nullable().min(0),
                systemId: event?.gameSystem?.systemIdRequired
                  ? Yup.string().required(t("validationErrors.required"))
                  : Yup.string()
              })}
              onSubmit={async (values) => {
                try {
                  if (!player?.id) {
                    await confirm({
                      title: t("termsOfService"),
                      description: <TermsOfServiceBox />,
                      dialogProps: {
                        sx: {
                          zIndex: 99999
                        }
                      },
                      confirmationText: t("confirmationText.iAgree"),
                      cancellationText: t("confirmationText.cancel")
                    });
                  }

                  if (!values.email || values.email === "") {
                    await confirm({
                      title: t("noEmail"),
                      description: t("noEmailDescription"),
                      dialogProps: {
                        sx: {
                          zIndex: 99999
                        }
                      },
                      confirmationText: t("confirmationText.yes"),
                      cancellationText: t("confirmationText.no")
                    });
                  }
                } catch (err) {
                  return;
                }
                setLoading(true);

                var body = {
                  eventId: event?.id,
                  ...values
                };

                if (teamPlayerId) {
                  body.teamPlayerId = teamPlayerId;
                }

                if (!values.email || values.email === "") {
                  delete body.email;
                }
                if (
                  !passwordUpdated ||
                  !event?.enablePasswords ||
                  event?.passwordlessScoring ||
                  !values.pin ||
                  values.pin === ""
                ) {
                  delete body.pin;
                }
                if (!values.armyId || values.armyId === "") {
                  delete body.armyId;
                }
                if (!values.subFactionId || values.subFactionId === "") {
                  delete body.subFactionId;
                }
                if (!values.characterId || values.characterId === "") {
                  delete body.characterId;
                }
                if (!values.teamId || values.teamId === "") {
                  delete body.teamId;
                }
                if (!values.fixedTable || values.fixedTable === "") {
                  delete body.fixedTable;
                }

                await submitPlayer(body);
                setLoading(false);
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                touched,
                values,
                setFieldValue,
                setFieldTouched
              }) => (
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <TextField
                        name="email"
                        label={
                          event?.gameSystem?.emailRequired
                            ? t("email")
                            : t("emailOptional")
                        }
                        required={event?.gameSystem?.emailRequired}
                        value={values.email}
                        variant="outlined"
                        fullWidth
                        onBlur={async (e) => {
                          handleBlur(e);
                          if (!player.id) {
                            if (
                              e.target.value &&
                              e.target.value.trim() !== ""
                            ) {
                              setLoading(true);
                              try {
                                var apiUser = await getData(
                                  `/users/${e.target.value.trim()}`,
                                  {
                                    queryStringParameters: {
                                      "expand[]": event?.gameSystem
                                        ?.usesSystemId
                                        ? ["team", "systemId"]
                                        : ["team"],
                                      gameSystemId: event?.gameSystemId
                                    }
                                  }
                                );
                                if (apiUser) {
                                  setFieldValue("userId", apiUser.id);
                                  if (apiUser.firstName)
                                    setFieldValue(
                                      "firstName",
                                      apiUser.firstName
                                    );
                                  if (apiUser.lastName)
                                    setFieldValue("lastName", apiUser.lastName);
                                  if (apiUser.team?.id)
                                    setFieldValue("teamId", apiUser.team.id);
                                  if (
                                    apiUser[
                                      event?.gameSystem?.systemIdName?.replace(
                                        / /g,
                                        "_"
                                      )
                                    ]
                                  )
                                    setFieldValue(
                                      "systemId",
                                      apiUser[
                                        event?.gameSystem?.systemIdName?.replace(
                                          / /g,
                                          "_"
                                        )
                                      ]
                                    );
                                } else {
                                  setFieldValue("userId", null);
                                }
                              } catch (err) {}
                              setLoading(false);
                            } else {
                              setFieldValue("userId", null);
                            }
                          }
                        }}
                        onChange={(e) => {
                          const trimmedString = e.target.value
                            .trim()
                            .toLowerCase();
                          setFieldValue("email", trimmedString);
                        }}
                        error={Boolean(touched.email && errors.email)}
                        helperText={touched.email && errors.email}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        name="firstName"
                        label={t("firstName")}
                        value={values.firstName}
                        variant="outlined"
                        fullWidth
                        required
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(touched.firstName && errors.firstName)}
                        helperText={touched.firstName && errors.firstName}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        name="lastName"
                        label={t("lastName")}
                        value={values.lastName}
                        variant="outlined"
                        fullWidth
                        required
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(touched.lastName && errors.lastName)}
                        helperText={touched.lastName && errors.lastName}
                      />
                    </Grid>
                    {(event?.gameSystem?.usesSystemId ||
                      event?.gameSystem?.systemIdRequired) && (
                      <Grid item xs={12}>
                        <TextField
                          name="systemId"
                          label={
                            event?.gameSystem?.systemIdName || t("systemId")
                          }
                          value={values.systemId}
                          variant="outlined"
                          fullWidth
                          required={event?.gameSystem?.systemIdRequired}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.systemId && errors.systemId)}
                          helperText={touched.systemId && errors.systemId}
                        />
                      </Grid>
                    )}
                    {!SUPPORTS_UY_PLATFORM_FEATURES && (
                      <Grid item xs={12}>
                        <GenericPicker
                          name="teamId"
                          label={t("clubTeamName")}
                          value={values.teamId}
                          variant="outlined"
                          fullWidth
                          onBlur={handleBlur}
                          handleChange={handleChange}
                          error={Boolean(touched.teamId && errors.teamId)}
                          helperText={touched.teamId && errors.teamId}
                          list={teams || []}
                          inclAny={false}
                          clearable
                          endAdornment={
                            <InputAdornment position="end">
                              <Button
                                sx={{ minWidth: "40px" }}
                                onClick={async (e) => {
                                  setLoading(true);
                                  await handleSetTeams(player);
                                  setLoading(false);
                                }}
                              >
                                <BCPRotateRight />
                              </Button>
                            </InputAdornment>
                          }
                        />
                        <FormHelperText>
                          {/* {t("helpText.teamRefreshDescription")} */}
                          {/* TODO: translations */}
                          Players can create or join a Club/Team in their
                          Account settings. If the user has created one and it
                          doesn't show in this list, please press the refresh
                          button
                        </FormHelperText>
                      </Grid>
                    )}
                    {!event?.boardGameEvent && (
                      <Grid item xs={12}>
                        <TextField
                          name="fixedTable"
                          label={t("fixedTable")}
                          value={values.fixedTable}
                          variant="outlined"
                          fullWidth
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(
                            touched.fixedTable && errors.fixedTable
                          )}
                          helperText={touched.fixedTable && errors.fixedTable}
                          type="number"
                          inputProps={{
                            min: 0
                          }}
                        />

                        <FormHelperText>
                          {/* {t("helpText.fixedTableDescription")} */}
                          {/* TODO: translations */}
                          By setting a fixed table, each round this player will
                          play their game on this table, regardless of placings.
                        </FormHelperText>
                      </Grid>
                    )}
                    {event?.gameSystem?.hasFactions && (
                      <>
                        <Grid item xs={12}>
                          <ArmyPicker
                            armies={armies}
                            name="armyId"
                            label={event?.gameSystem?.factionLabel || "Faction"}
                            value={values.armyId}
                            handleChange={(e) => {
                              handleChange(e);
                              let army = armies.filter(
                                (el) => el.id === e.target.value
                              )[0];
                              setArmyName(army?.name);
                              setFieldValue("subFactionId", "");
                              setFieldValue("characterId", "");
                            }}
                            error={Boolean(touched.armyId && errors.armyId)}
                            helperText={touched.armyId && errors.armyId}
                            clearable
                          />
                        </Grid>

                        {event?.gameSystem?.hasSubFactions ||
                        event?.gameSystem?.subFactionRequired ? (
                          <Grid item xs={12}>
                            <GenericPicker
                              name="subFactionId"
                              label={
                                event?.gameSystem?.subFactionLabel ||
                                "Sub Faction"
                              }
                              value={values.subFactionId}
                              handleChange={handleChange}
                              inclAny={false}
                              clearable
                              list={armyDict?.[values.armyId] || []}
                              error={Boolean(
                                touched.subFactionId && errors.subFactionId
                              )}
                              helperText={
                                touched.subFactionId && errors.subFactionId
                              }
                              disabled={!values.armyId || values.armyId === ""}
                              required={
                                event?.gameSystem?.subFactionRequired || false
                              }
                            />
                          </Grid>
                        ) : (
                          <></>
                        )}
                      </>
                    )}
                    {event?.gameSystem?.supportsCharacters ? (
                      <Grid item xs={12}>
                        {characters ? (
                          <GenericPicker
                            name="characterId"
                            label={
                              event?.gameSystem?.characterLabel || "Character"
                            }
                            value={values.characterId}
                            handleChange={handleChange}
                            inclAny={false}
                            clearable
                            list={characters || []}
                            error={Boolean(
                              touched.characterId && errors.characterId
                            )}
                            helperText={
                              touched.characterId && errors.characterId
                            }
                            disabled={!values.armyId || values.armyId === ""}
                          />
                        ) : (
                          <TextField
                            disabled
                            label={
                              event?.gameSystem?.characterLabel || "Character"
                            }
                            value={player?.characterName || ""}
                            color="primary"
                            variant="outlined"
                            fullWidth
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <CircularProgress />
                                </InputAdornment>
                              )
                            }}
                          />
                        )}
                      </Grid>
                    ) : (
                      <></>
                    )}
                    {event.enablePasswords && !event.passwordlessScoring && (
                      <Grid item xs={12}>
                        <TextField
                          name="pin"
                          label={t("selfScorePin")}
                          value={values.pin}
                          variant="outlined"
                          fullWidth
                          onBlur={(e) => {
                            handleBlur(e);
                          }}
                          onChange={(e) => {
                            handleChange(e);
                            setPasswordUpdated(true);
                          }}
                          onFocus={(e) => {
                            setFieldValue("pin", "");
                          }}
                          error={Boolean(touched.pin && errors.pin)}
                          helperText={touched.pin && errors.pin}
                          type="password"
                        />
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Typography variant="caption" color="text.secondary">
                        In order to use the Website or Services provided by{" "}
                        {globalVars?.site?.title} you must be 13 years of age or
                        older. By submitting your information, you confirm that
                        you are over 18 years of age, or if you are between 13
                        and 18 years of age, you have your parent or legal
                        guardian's permission to use our Website or Services.
                        Please review our{" "}
                        <Link href="/privacy" target="_blank">
                          Privacy
                        </Link>{" "}
                        and{" "}
                        <Link href="/terms" target="_blank">
                          Website Terms of Use
                        </Link>{" "}
                        for more information.
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      xs={
                        !organize
                          ? !player.id
                            ? 12
                            : 10
                          : !player.id
                            ? !teamSubmitPlayer
                              ? 6
                              : 12
                            : player.checkedIn
                              ? 10
                              : 5
                      }
                    >
                      <Button
                        color="success"
                        fullWidth
                        variant="contained"
                        type="submit"
                      >
                        {player.id ? t("update") : t("register")}
                      </Button>
                    </Grid>

                    {organize &&
                      !player.checkedIn &&
                      (player.id || !teamSubmitPlayer) && (
                        <Grid item xs={!player.id ? 6 : 5}>
                          <Button
                            color="success"
                            fullWidth
                            variant="contained"
                            onClick={async (e) => {
                              setFieldTouched("firstName");
                              setFieldTouched("lastName");
                              if (event?.gameSystem?.emailRequired) {
                                setFieldTouched("email");
                                if (
                                  !validateEmail(values.email) ||
                                  !values.firstName ||
                                  values.firstName.trim() === "" ||
                                  !values.lastName ||
                                  values.lastName.trim() === ""
                                ) {
                                  return;
                                }
                              } else {
                                if (
                                  !values.firstName ||
                                  values.firstName.trim() === "" ||
                                  !values.lastName ||
                                  values.lastName.trim() === ""
                                ) {
                                  return;
                                }
                              }

                              var body = {
                                ...values,
                                checkedIn: true,
                                dropped: false,
                                eventId: event?.id
                              };

                              try {
                                if (
                                  !(
                                    player?.listId || player?.armyListObjectId
                                  ) &&
                                  event.listsAtCheckin
                                ) {
                                  await confirm({
                                    title: t("noListAtCheckin", {
                                      listLabel:
                                        event?.gameSystem?.listLabel || "List"
                                    }),
                                    description: t(
                                      "noListAtCheckinDescription",
                                      {
                                        listLabel:
                                          event?.gameSystem?.listLabel || "list"
                                      }
                                    ),
                                    dialogProps: {
                                      sx: {
                                        zIndex: 99999
                                      }
                                    },
                                    confirmationText: t("confirmationText.yes"),
                                    cancellationText: t("confirmationText.no")
                                  });
                                }

                                if (!player?.id) {
                                  await confirm({
                                    title: t("termsOfService"),
                                    description: <TermsOfServiceBox />,
                                    dialogProps: {
                                      sx: {
                                        zIndex: 99999
                                      }
                                    },
                                    confirmationText: t(
                                      "confirmationText.iAgree"
                                    ),
                                    cancellationText: t(
                                      "confirmationText.cancel"
                                    )
                                  });

                                  if (!values.email || values.email === "") {
                                    await confirm({
                                      title: t("noEmail"),
                                      description: t("noEmailDescription"),
                                      dialogProps: {
                                        sx: {
                                          zIndex: 99999
                                        }
                                      },
                                      confirmationText: t(
                                        "confirmationText.yes"
                                      ),
                                      cancellationText: t("confirmationText.no")
                                    });
                                  }
                                }
                              } catch (err) {
                                return;
                              }

                              await submitPlayer(body);
                            }}
                          >
                            {t("checkIn")}
                          </Button>
                        </Grid>
                      )}
                    {player.id && (
                      <Grid item xs={2}>
                        <Button
                          color="secondary"
                          variant="contained"
                          fullWidth
                          onClick={(e) => {
                            setOptionsAnchorEl(e.currentTarget);
                          }}
                          sx={{ minWidth: "100%", maxWidth: "100%" }}
                        >
                          <BCPEllipsisVertical />
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                  {player.id && (
                    <PlayerOptionsMenu
                      organize={organize}
                      captain={captain}
                      event={event}
                      player={player}
                      transaction={transaction}
                      anchorEl={optionsAnchorEl}
                      setAnchorEl={setOptionsAnchorEl}
                      setLoading={setLoading}
                      setRefreshPlayers={setRefreshPlayers}
                      setPlayer={setPlayer}
                      setArmyModalOpen={setArmyModalOpen}
                      setGroupInfoModalOpen={setGroupInfoModalOpen}
                      setSavedPlayer={setSavedPlayer}
                      setCaptainIsPlayer={setCaptainIsPlayer}
                      setTeamPlayer={setTeamPlayer}
                      deletePlayer={deletePlayer}
                      showViewPlayer={false}
                      t={t}
                    />
                  )}
                </form>
              )}
            </Formik>
          </Box>
        ) : (
          <></>
        )}
      </Modal>
      {!captain && (
        <ArmyListComponent
          modal
          event={event}
          armies={armies}
          open={armyModalOpen}
          setOpen={setArmyModalOpen}
          player={player}
          setPlayer={setPlayer}
          organize={true}
          setRefreshPlayers={setRefreshPlayers}
          tArmyList={tArmyList}
        />
      )}

      {groupInfoModalOpen && (
        <PlayerGroupInfoModal
          event={event}
          open={groupInfoModalOpen}
          setOpen={setGroupInfoModalOpen}
          player={player}
          setPlayer={setPlayer}
          organize={true}
          setRefreshPlayers={setRefreshPlayers}
          setProcessing={setLoading}
        />
      )}

      {Boolean(loading) && <ModalLoadingFull />}
    </>
  );
}
